/* <product-form>: submits the add-to-cart form over fetch, shows inline
   errors and a confirmation, and refreshes the header cart count. A submit
   from a [data-buy-now] button (inside the form, or tied to it with the form
   attribute, as the sticky bar's are) goes on to checkout once the item is in. */
window.OlyJoy.cartSections = window.OlyJoy.cartSections || ['cart-icon-bubble'];

class ProductForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.button = this.querySelector('[type="submit"]');
    this.error = this.querySelector('.product-form__error');
    this.success = this.querySelector('.product-form__success');
    this.form.addEventListener('submit', this.onSubmit);
  }

  onSubmit = async (event) => {
    event.preventDefault();
    const submitter = event.submitter || this.button;
    if (submitter.disabled) return;
    const buyNow = submitter.hasAttribute('data-buy-now');
    this.busyButton = submitter;
    this.setBusy(true);
    this.showError('');
    this.success.hidden = true;

    const body = new FormData(this.form);
    // Radios are named options[...] for the picker only; the server needs the hidden id.
    for (const key of [...body.keys()]) if (key.startsWith('options[')) body.delete(key);
    body.append('sections', window.OlyJoy.cartSections.join(','));
    body.append('sections_url', window.location.pathname);

    try {
      const response = await fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { Accept: 'application/javascript' },
        body,
      });
      const data = await response.json();
      if (data.status) {
        this.showError(data.description || window.cartStrings.error);
        return;
      }
      if (buyNow) {
        window.location.href = submitter.value || '/checkout';
        return;
      }
      document.dispatchEvent(new CustomEvent('cart:added', { detail: { sections: data.sections, item: data } }));
      this.refreshBubble(data.sections);
      this.success.hidden = false;
    } catch {
      this.showError(window.cartStrings.error);
    } finally {
      this.setBusy(false);
    }
  };

  refreshBubble(sections) {
    const bubble = document.getElementById('cart-icon-bubble');
    if (!bubble || !sections?.['cart-icon-bubble']) return;
    const fresh = window.OlyJoy.parseSectionHTML(sections['cart-icon-bubble'], '.shopify-section');
    if (fresh) bubble.innerHTML = fresh.innerHTML;
  }

  setBusy(busy) {
    const button = this.busyButton || this.button;
    button.setAttribute('aria-busy', String(busy));
    button.classList.toggle('is-loading', busy);
  }

  showError(message) {
    this.error.textContent = message;
    this.error.hidden = !message;
    // A submit from the sticky bar happens far from the form; bring the error into view.
    if (message && this.busyButton && !this.contains(this.busyButton)) {
      this.error.scrollIntoView({ block: 'center' });
    }
  }
}
customElements.define('product-form', ProductForm);
